import { getResmgrRoleConfig } from 'openstack/components/infrastructure/actions'
import { flatten, uniq } from 'ramda'

export const getValidVolumeTypes = async ({
  hosts,
  setActiveVolumeBackends,
  setLoadingVolumeBackends,
}) => {
  const storageHosts = hosts.filter((host) => host.roles.includes('persistent-storage'))
  const onlineStorageHosts = storageHosts.filter((host) => host?.info?.responding)
  const results = await Promise.allSettled(
    onlineStorageHosts.map((host) =>
      getResmgrRoleConfig({ role: 'pf9-cindervolume-config', host: host }),
    ),
  )
  const volumeBackends = results.map((result: any) => {
    if (result?.value?.backends) {
      const values = Object.values(result.value.backends)
      return uniq(values.map((value: any) => value.volume_backend_name))
    }
    return []
  })
  const uniqueVolumeBackends = uniq(flatten(volumeBackends))
  setActiveVolumeBackends(uniqueVolumeBackends)
  setLoadingVolumeBackends(false)
}
